<template>
  <div class="reserve">
    <div class="reserve-form">
      <van-form @submit="getCardInfoWeb">
        <van-field
          v-model="searchForm.card_no"
          center
          clearable
          label="卡号"
          placeholder=""
        >

        </van-field>
        <van-field
          v-model="searchForm.card_pwd"
          center
          clearable
          label="查询密码"
          type="password"
          placeholder="请输入查询密码非卡密码"
        >

        </van-field>

        <div style="margin: 16px;">
          <el-button
            type="primary"
            size="small"
            round
            @click="getCardInfoWeb"
            :loading="loading"
          >搜索</el-button>
        </div>

      </van-form>

    </div>
    <div class="reserve-table-mobile">

      <div class="reserve-table-mobile-item-content-infor">
        <div class="reserve-table-mobile-item-content-lable">
          卡类型：
        </div>
        <div class="reserve-table-mobile-item-content-text">
          {{  cardInfo.card_type  }}
        </div>
      </div>

      <div class="reserve-table-mobile-item-content-infor">
        <div class="reserve-table-mobile-item-content-lable">
          激活状态:
        </div>
        <div class="reserve-table-mobile-item-content-text">
          {{  cardInfo.active_status_name  }}
        </div>
      </div>

      <div class="reserve-table-mobile-item-content-infor">
        <div class="reserve-table-mobile-item-content-lable">
          激活时间:
        </div>
        <div class="reserve-table-mobile-item-content-text">
          {{  cardInfo.active_time  }}
        </div>
      </div>
      <div class="reserve-table-mobile-item-content-infor">
        <div class="reserve-table-mobile-item-content-lable">
          电签状态:
        </div>
        <div class="reserve-table-mobile-item-content-text">
          {{  cardInfo.oak_response_str  }}
        </div>
      </div>
      <div class="reserve-table-mobile-item-content-infor">
        <div class="reserve-table-mobile-item-content-lable">
          电签时间:
        </div>
        <div class="reserve-table-mobile-item-content-text">
          <!-- {{  cardInfo.hasOwnProperty('oak_response_time') ? cardInfo.oak_response_time || '未电签'  : '' }} -->
          {{  cardInfo.oak_response_time  }}
        </div>
      </div>
      <div
        class="reserve-table-mobile-item-content-infor"
        v-if="isFamilyCard"
      >
        <div class="reserve-table-mobile-item-content-lable">
          主卡人:
        </div>
        <div class="reserve-table-mobile-item-content-text">
          {{  cardInfo.main_card_name  }}
        </div>
      </div>
      <div
        class="reserve-table-mobile-item-content-infor"
        v-else
      >
        <div class="reserve-table-mobile-item-content-lable">
          激活人:
        </div>
        <div class="reserve-table-mobile-item-content-text">
          {{  cardInfo.active_name  }}
        </div>
      </div>

      <div class="reserve-table-mobile-item-content-infor">
        <div class="reserve-table-mobile-item-content-lable">
          手机号:
        </div>
        <div class="reserve-table-mobile-item-content-text">
          {{  cardInfo.active_mobile_str  }}
        </div>
      </div>
      <div class="reserve-table-mobile-item-content-infor">
        <div class="reserve-table-mobile-item-content-lable">
          证件号:
        </div>
        <div class="reserve-table-mobile-item-content-text">
          {{  cardInfo.active_id_no_str  }}
        </div>
      </div>
      <div class="reserve-table-mobile-item-content-infor">
        <div class="reserve-table-mobile-item-content-lable">
          所属渠道:
        </div>
        <div class="reserve-table-mobile-item-content-text">
          {{  cardInfo.channel_name  }}
        </div>
      </div>
      <div class="reserve-table-mobile-item-content-infor">
        <div class="reserve-table-mobile-item-content-lable">
          创建时间:
        </div>
        <div class="reserve-table-mobile-item-content-text">
          {{  cardInfo.create_time_str  }}
        </div>
      </div>
      <div
        class="reserve-table-mobile-item-content-infor"
        v-if="cardInfo.oak_request_type"
      >
        <div class="reserve-table-mobile-item-content-lable">
          卡类型:
        </div>
        <div class="reserve-table-mobile-item-content-text">
          {{ cardInfo.oak_request_type }}
        </div>
      </div>

      <template v-if="isFamilyCard">
        <template v-for="user in cardInfo.families">
          <div
            class="reserve-table-mobile-item-content-infor"
            :key="user.id"
          >
            <div class="reserve-table-mobile-item-content-lable">
              主卡人{{ user.relation_name }}:
            </div>
            <div class="reserve-table-mobile-item-content-text">
              {{ user.name }}
            </div>
          </div>
          <div
            class="reserve-table-mobile-item-content-infor"
            :key="user.id"
          >
            <div class="reserve-table-mobile-item-content-lable">
              电签时间:
            </div>
            <div class="reserve-table-mobile-item-content-text">
              {{ user.sign_time || '未电签'  }}
            </div>
          </div>
        </template>

      </template>
      <div
        class="reserve-table-mobile-item-content-infor"
        v-if="cardInfo.oak_request_msg"
      >
        <div class="reserve-table-mobile-item-content-lable">
          日志信息:
        </div>
        <div
          class="reserve-table-mobile-item-content-text"
          v-html="cardInfo.oak_request_msg"
        >
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import moment from "moment";
import hisService from "@/apis/his/index.js";
// import { Toast } from "vant";
// import { MessageBox, Message } from "element-ui";

export default {
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPod|BlackBerry/i.test(
        navigator.userAgent
      ),

      searchForm: {},
      loading: false,
      cardInfo: {},
      isFamilyCard: false,
    };
  },

  async created() {
    // this.getCardInfoWeb();
  },
  methods: {
    moment,
    // pwdChange(val) {
    //   // 将密码转存到另一个字段，
    //   this.searchForm.card_pwd_str = val;
    //   //并把页面上展示的card_pwd字段替换为*号
    //   this.searchForm.card_pwd = val.replace(/./g, "*");
    // },
    getCardInfoWeb() {
      const { searchForm } = this;
      const params = {
        // card_no: "test20231031001",
        // card_pwd: "lmt520",
        ...searchForm,
      };
      this.isFamilyCard = false;

      hisService
        .cardInfoWeb(params)
        .then((res) => {
          debugger;
          if (res.card_type && res.card_type.indexOf("家庭") > -1) {
            this.isFamilyCard = true;
            if (res.families) {
              res.families.some((item) => {
                if (item.relation == 0) {
                  res.main_card_name = item.name;
                  return true;
                }
              });
              res.families.splice(
                res.families.findIndex((item) => item.relation == 0),
                1
              );
            }
          }
          this.cardInfo = res;
        })
        .catch(() => {
          this.cardInfo = {};
        });
    },
  },
};
</script>

<style lang="scss">
.reserve {
  height: 100%;
  overflow: hidden;
  // overflow: scroll;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .el-button {
    width: 100%;
    background-color: #e7635e;
    border: none;
  }
  .reserve-title {
    margin-bottom: 10px;
    color: #e7635e;
    min-height: 40px;
  }
  .reserve-table {
    flex: 1;
    overflow: hidden;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-date-editor.el-input__inner {
    width: 220px;
  }
  .reserve-table-mobile {
    flex: 1;
    overflow: scroll;
  }
  .van-cell {
    align-items: center;
  }
  .reserve-table-mobile-item-title-name {
    font-size: 15px;
    font-weight: 600;
  }

  .reserve-table-mobile-item-title {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    align-items: center;
    .reserve-table-mobile-item-title-right {
      text-align: right;
      flex-shrink: 0;
      font-size: 15px;
    }
  }
  .reserve-table-mobile-item-content-infor {
    display: flex;
    padding: 3px 0;
    .reserve-table-mobile-item-content-lable {
      width: 85px;
      flex-shrink: 0;
      color: #999;
    }
    .flex-width-110 {
      width: 110px;
    }
    .reserve-table-mobile-item-content-text {
      text-align: left;
      color: #000;
    }
  }
  // .van-cell::after {
  //   display: none;
  // }
  .van-collapse-item--border::after {
    border-top: 4px solid #eee;
    left: 0;
    right: 0;
  }
  .van-collapse-item__content {
    // padding-top: 0;
    font-size: 12px;
  }
}
.reserve-table-money {
  display: flex;
  input {
    text-align: center;
  }
  .van-cell {
    padding: 0;
  }
  .van-cell::after {
    content: "";
    border-bottom: 0;
  }
}
</style>